export default __webpack_public_path__ + "static/media/file-download.d644ee0a.svg";